import type { FC } from 'react';
import Content from '../Content';
import ButtonGoToSession from '../../Shared/ButtonGoToSession';
import ButtonHideSession from '../../Shared/ButtonHideSession';
import { WidthProperties } from '../../../../../../core/domain/map';

type Props = {
    networkProperties: WidthProperties | null;
};

const RoadDataPopupOnClick: FC<Props> = ({ networkProperties }) => {
    if (!networkProperties) {
        return null;
    }

    return (
        <>
            <Content properties={networkProperties} />
            <ButtonGoToSession
                sessionId={networkProperties.sessionId}
                cumulStartSession={Number(networkProperties.imageCumulStart)}
            />
            <ButtonHideSession sessionId={networkProperties.sessionId} />
        </>
    );
};

export default RoadDataPopupOnClick;
